import wrapWithProviders from "./wrap-with-providers";

// TODO probably this could be moved to wrap-with-providers
import "./src/styles/global.css";

export const wrapRootElement = wrapWithProviders;
